import moment from 'moment-timezone';
import { LocalStorage as SessionStorage } from 'quasar';
import Vue from 'vue';

const authUserData = getAuthUserData();
const timezone = determineTimezone(authUserData);

const globalData = createGlobalData(timezone);

Vue.mixin({
  computed: {
    $timezone: {
      get: function () {
        return globalData.$data.$timezone;
      },
      set: function (newTimezone) {
        globalData.$data.$timezone = newTimezone;
      },
    },
  },
});

function getAuthUserData() {
  return JSON.parse(SessionStorage.getItem('authUserData'));
}

function determineTimezone(authUserData) {
  if (authUserData && authUserData.timezone) {
    return authUserData.timezone;
  }
  const timezoneGuess = moment.tz.guess();
  return timezoneGuess === 'Asia/Calcutta' ? 'Asia/Kolkata' : timezoneGuess;
}

function createGlobalData(timezone) {
  return new Vue({
    data: { $timezone: timezone },
  });
}
